import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentDeleteAction from './equipmentDelete.action.json' with { type: 'json' }
import { equipmentObject } from '../equipmentObject'

const equipmentDeleteDefinition = defineAction({
  ...equipmentDeleteAction,

  input: equipmentObject.pick({
    id: true,
  }),
  output: z.object({}),
})

export default equipmentDeleteDefinition
